import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { shiftExtendedSchema } from '../types';

export type CreateStartShiftMutationParams = {
	balance: number;
};

export const createStartShiftMutation = () =>
	createAuthMutation({
		params: declareParams<CreateStartShiftMutationParams>(),
		request: {
			method: 'POST',
			url: '/shift',
			body: (data) => data,
		},
		response: {
			contract: zodContract(shiftExtendedSchema),
		},
	});
